import { EQuickQuoteFinanceType } from '@/context/borrower';

export function getFinanceType(): EQuickQuoteFinanceType {
  return EQuickQuoteFinanceType.CONSUMER_SECURED;
}
